import axiosHttp from "../../../../../services/interceptor";

const uid = () => Math.random().toString(36).slice(2, 10);

export const emptyFuelRow = () => ({
    id: uid(),
    fuelType: "",
    cf: "",
    amount: "",
});

export const emptyCorrectionRow = () => ({
    id: uid(),
    fuelType: "",
    cf: "",
    fcVoyage: "",
    tfj: "",
    fcElectrical: "",
    fcBoiler: "",
    fcOther: "",
});

export const emptyPeriod = (i) => ({
    id: `period-${Date.now()}-${i}`,
    periodLabel: `VERIFIED REPORTING PERIOD ${i + 1}`,
    reportingStart: "",
    reportingEnd: "",
    distanceTravelled: "",
    distanceExcluded: "",
    fuelConsumptions: [emptyFuelRow()],
    correctionFactors: [emptyCorrectionRow()],
    confirmedAt: null,
    dirty: false,
    isOpen: true,
});


export const toNumber = (v) => {
    if (v === "" || v == null) return null;
    const num = Number(v);
    return isNaN(num) ? null : num;
};

export const buildSavePayload = (periods) => ({
    periods: periods.map((p) => ({
        periodId: p?.periodId,
        reportingStart: p?.reportingStart,
        reportingEnd: p?.reportingEnd,
        distanceTravelled: toNumber(p.distanceTravelled),
        distanceExcluded: toNumber(p.distanceExcluded),
        fuelConsumptions: p.fuelConsumptions.map((f) => ({
            fuelType: f.fuelType,
            cf: toNumber(f.cf),
            amount: toNumber(f.amount),
        })),
        correctionFactors: p.correctionFactors.map((c) => ({
            fuelType: c.fuelType,
            cf: toNumber(c.cf),
            fcVoyage: toNumber(c.fcVoyage),
            tfj: toNumber(c.tfj),
            fcElectrical: toNumber(c.fcElectrical),
            fcBoiler: toNumber(c.fcBoiler),
            fcOther: toNumber(c.fcOther),
        })),
    })),
});

export const hydrateFromApi = (response) => {
    const periods = response?.periods ?? [];

    return periods.map((p, i) => ({
        id: p.periodId,
        periodLabel: `VERIFIED REPORTING PERIOD ${i + 1}`,
        periodId: p.periodId ?? null,
        confirmedAt: p.periodId != null ? true : null,
        dirty: false,

        reportingStart: (p.reportingStart ?? "").split("T")[0],
        reportingEnd: (p.reportingEnd ?? "").split("T")[0],

        distanceTravelled: String(p.distanceTravelled ?? ""),
        distanceExcluded: String(p.distanceExcluded ?? ""),

        fuelConsumptions: (p.fuelConsumptions ?? []).map((f, ri) => ({
            id: `fuel-${Date.now()}-${i}-${ri}`,
            isFromDatabase: true,
            fuelType: f.fuelType,
            cf: String(f.cf ?? ""),
            amount: String(f.amount ?? ""),
        })),

        correctionFactors: (p.correctionFactors ?? []).map((c, ri) => ({
            id: `corr-${Date.now()}-${i}-${ri}`,
            isFromDatabase: true,
            fuelType: c.fuelType,
            cf: String(c.cf ?? ""),
            fcVoyage: String(c.fcVoyage ?? ""),
            tfj: String(c.tfj ?? ""),
            fcElectrical: String(c.fcElectrical ?? ""),
            fcBoiler: String(c.fcBoiler ?? ""),
            fcOther: String(c.fcOther ?? ""),
        })),
        isOpen: i === 0,
    }));
};

export const saveVerifiedCii = async (reportMstId, payload) => {
    const { data } = await axiosHttp.post(
        `/api/Cii/SaveVerifiedCii?reportMstId=${reportMstId}`,
        payload
    );
    return data;
};

export const getVerifiedInputCii = async (reportMstId) => {
    const { data } = await axiosHttp.get(
        `/api/Cii/GetVerifiedInputCii?reportMstId=${reportMstId}`
    );
    return data;
};

export const removeVerifiedCii = async (reportMstId, periodId) => {
    const { data } = await axiosHttp.delete(
        `/api/Cii/RemoveVerifiedCii?reportMstId=${reportMstId}&periodId=${periodId}`
    );
    return data;
};